// extracted by mini-css-extract-plugin
module.exports = {"root":"links-module__root___16n_3","link":"links-module__link___3-Wsz","active":"links-module__active___15S9q"};